import { Workspace } from '@keeps-platform-frontend-workspace/kp-keeps';
import { Action, createReducer } from '@ngrx/store';
export interface State {
  workspace: Workspace | null;
}

const initialState: State = {
  workspace: null,
};

const workspaceReducer = createReducer(initialState);

// eslint-disable-next-line
export function reducer(state: State | undefined, action: Action) {
  return workspaceReducer(state, action);
}
